import { Alert, Form } from 'antd';
import type { FormInstance } from 'antd';
import { Input } from '@ydistri/ds';
import React from 'react';

export interface ScopeCreateFormValues {
  name: string;
}

interface ScopeCreateFormProps {
  form: FormInstance<ScopeCreateFormValues>;
  onSubmit: (name: string) => void | Promise<void>;
  actions?: React.ReactNode;
  autoFocus?: boolean;
  description?: React.ReactNode;
  error?: string;
  initialName?: string;
  inputDisabled?: boolean;
}

const ScopeCreateForm: React.FC<ScopeCreateFormProps> = ({
  form,
  onSubmit,
  actions,
  autoFocus,
  description,
  error,
  initialName,
  inputDisabled,
}) => (
  <Form
    form={form}
    initialValues={{ name: initialName }}
    layout="vertical"
    onFinish={values => void onSubmit(values.name.trim())}
  >
    {description}
    {error && <Alert message={error} showIcon type="error" />}
    <Form.Item<ScopeCreateFormValues>
      label="Name"
      name="name"
      rules={[{ required: true, whitespace: true, message: 'Enter a Scope name.' }]}
    >
      <Input autoFocus={autoFocus} disabled={inputDisabled} placeholder="Scope name" />
    </Form.Item>
    {actions}
  </Form>
);

export default ScopeCreateForm;
